import { httpApi } from '@app/api/http.api';
import { IClient } from '@app/interfaces/client';
import { SearchQueryRequest, SearchQueryResponse } from '@app/interfaces/interfaces';

const baseSlug = '/clients';

export const getClient = async (id: string): Promise<IClient> => {
  try {
    const { data } = await httpApi.get<IClient>(`${baseSlug}/${id}`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const createClient = async (payload: Partial<IClient>): Promise<IClient> => {
  try {
    const { data } = await httpApi.post<IClient>(`${baseSlug}`, payload);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const updateClient = async (id: string, payload: Partial<IClient>): Promise<IClient> => {
  try {
    const { data } = await httpApi.patch<IClient>(`${baseSlug}/${id}`, payload);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const deleteClient = async (id: string): Promise<undefined> => {
  try {
    const { data } = await httpApi.delete<undefined>(`${baseSlug}/${id}`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const getListWithPagination = async (
  url: string,
  queryPayload: SearchQueryRequest,
): Promise<SearchQueryResponse> => {
  try {
    const { data } = await httpApi.get<SearchQueryResponse>(
      `${url}?${new URLSearchParams(queryPayload as Record<string, string>).toString()}`,
    );
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const getClientListWithPagination = async (queryPayload: SearchQueryRequest): Promise<SearchQueryResponse> => {
  return getListWithPagination(`${baseSlug}/queryClientsWithPagination`, queryPayload) as Promise<SearchQueryResponse>;
};

export const getClientOptions = async (): Promise<IClient[]> => {
  try {
    const { data } = await httpApi.get<IClient[]>(`${baseSlug}/options`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};
